import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from 'ui/drawer'
import { toast } from 'ui/sonner'

import { LinkButton } from '~/components/link-button'
import { config } from '~/config/env'
import { useAccountStore } from '~/stores/account'

export const ReachingLimit = () => {
  const { t } = useTranslation()
  const coins = useAccountStore(state => state.coins) ?? 0
  const planId = useAccountStore(state => state.planId)
  const [isDrawer, seIsDrawer] = useState(false)
  const coinsOnRenderRef = useRef<number | undefined>(coins)
  const isDrawerShownRef = useRef(false)

  const isFreePlan = planId === config.VITE_FREE_PLAN_ID

  useEffect(() => {
    if (isFreePlan || !Number.isInteger(coins) || isDrawerShownRef.current) return

    const isInitialCoinsWerePositive = Number.isInteger(coinsOnRenderRef.current) && (coinsOnRenderRef.current ?? 0) > 0
    const openDrawer = (coins ?? 0) <= 0 && isInitialCoinsWerePositive
    if (!openDrawer) return

    seIsDrawer(true)
    isDrawerShownRef.current = true
  }, [isFreePlan, coins])

  if (!isDrawer) return null

  return (
    <Drawer
      onOpenChange={nextOpen => {
        if (!nextOpen) seIsDrawer(false)
      }}
      open
    >
      <DrawerContent>
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <DrawerTitle>{t('You have reached the subscription limit')}</DrawerTitle>
          </DrawerHeader>
          <DrawerDescription>{t('You have no remaining coins')}</DrawerDescription>
          {isFreePlan && (
            <div>
              <LinkButton className="mt-3 block" onClick={() => toast.dismiss()} to="/settings/subscription/change">
                {t('Change subscription')}
              </LinkButton>
            </div>
          )}
          {!isFreePlan && <p>{t('Adding more coins is coming soon')}</p>}
          <DrawerFooter className="py-4">
            <DrawerClose render={<Button variant="outline" />}>{t('Close')}</DrawerClose>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
